import React from "react";
import {
  AbsoluteFill,
  Audio,
  Img,
  interpolate,
  spring,
  staticFile,
  useCurrentFrame,
  useVideoConfig,
  Easing,
} from "remotion";

// Shared Scene A: Desktop Browser Nixlev
const SceneA: React.FC = () => {
  return (
    <div
      style={{
        width: 860,
        height: 520,
        backgroundColor: "#FFFFFF",
        borderRadius: 26,
        border: "2px solid #E5E7EB",
        boxShadow: "0 35px 80px rgba(0,0,0,0.08)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          height: 48,
          backgroundColor: "#F9FAFB",
          borderBottom: "1px solid #E5E7EB",
          padding: "0 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: 8 }}>
          <div style={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: "#FF5F56" }} />
          <div style={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: "#FFBD2E" }} />
          <div style={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: "#27C93F" }} />
        </div>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "4px 20px",
            fontSize: 14,
            fontWeight: 700,
            color: "#374151",
          }}
        >
          🔒 nixlev.com/@kreator
        </div>
        <div style={{ fontSize: 14, fontWeight: 800, color: "#059669" }}>Toko Online ↗</div>
      </div>
      <Img
        src={staticFile("nixlev_desktop.png")}
        style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center" }}
      />
    </div>
  );
};

// Shared Scene B: QRIS & Notification Card
const SceneB: React.FC = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 24, width: 860 }}>
      {/* QRIS Card */}
      <div
        style={{
          width: 500,
          backgroundColor: "#FFFFFF",
          border: "2px solid #10B981",
          borderRadius: 28,
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow: "0 25px 60px rgba(16, 185, 129, 0.12)",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 800, color: "#065F46", marginBottom: 14 }}>
          QRIS PEMBAYARAN INSTAN
        </div>
        <div
          style={{
            width: 180,
            height: 180,
            backgroundColor: "#111827",
            borderRadius: 18,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: 90,
          }}
        >
          ⬛
        </div>
        <div
          style={{
            marginTop: 14,
            backgroundColor: "#ECFDF5",
            color: "#047857",
            border: "1px solid #A7F3D0",
            padding: "6px 16px",
            borderRadius: 20,
            fontSize: 14,
            fontWeight: 800,
          }}
        >
          ✔ Terverifikasi Otomatis
        </div>
      </div>

      {/* Saldo Notification Card */}
      <div
        style={{
          width: 580,
          backgroundColor: "#FFFFFF",
          border: "2px solid #10B981",
          borderRadius: 24,
          padding: "20px 28px",
          display: "flex",
          alignItems: "center",
          gap: 20,
          boxShadow: "0 25px 60px rgba(27, 59, 43, 0.18)",
        }}
      >
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: 18,
            backgroundColor: "#ECFDF5",
            border: "2px solid #A7F3D0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2.5">
            <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
            <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
          </svg>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontSize: 17, fontWeight: 800, color: "#065F46" }}>QRIS Pembayaran Berhasil</span>
            <span style={{ fontSize: 13, color: "#6B7280", fontWeight: 600 }}>02:14 AM</span>
          </div>
          <div style={{ fontSize: 32, fontWeight: 900, color: "#047857", marginTop: 2 }}>+Rp 150.000</div>
          <div style={{ fontSize: 13, color: "#4B5563" }}>File otomatis terkirim ke WhatsApp & Email</div>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// 1. TRANSISI: HARD CUT ON BEAT (Apple Style)
// ==========================================
export const TransisiHardCut: React.FC = () => {
  const frame = useCurrentFrame();
  const cutFrame = 90; // Cut at 3.0s
  const isSceneB = frame >= cutFrame;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#F4F2EC",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Inter', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Label Badge */}
      <div
        style={{
          position: "absolute",
          top: 260,
          backgroundColor: "#111827",
          color: "#FFFFFF",
          padding: "12px 28px",
          borderRadius: 30,
          fontSize: 22,
          fontWeight: 900,
          letterSpacing: "0.05em",
        }}
      >
        CONTOH 1: HARD CUT ON BEAT (APPLE STYLE)
      </div>

      <div style={{ position: "absolute", top: 330, fontSize: 18, color: "#4B5563", fontWeight: 700 }}>
        Nol efek visual, pergantian seketika 1 frame pada ketukan drum.
      </div>

      {/* SFX on Cut */}
      {frame === cutFrame && <Audio src={staticFile("ui-pop.mp3")} volume={0.8} />}

      {/* Content */}
      <div style={{ transform: `scale(${isSceneB ? 1 : 1})` }}>
        {!isSceneB ? <SceneA /> : <SceneB />}
      </div>
    </AbsoluteFill>
  );
};

// ==========================================
// 2. TRANSISI: PUSH-THROUGH (Dolly Zoom Through)
// ==========================================
export const TransisiPushThrough: React.FC = () => {
  const frame = useCurrentFrame();
  const transitionStart = 75;
  const transitionEnd = 105;

  // Progress 0 to 1 during transition
  const progress = interpolate(
    frame,
    [transitionStart, transitionEnd],
    [0, 1],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.16, 1, 0.3, 1) }
  );

  // Scene A scales up past camera and blurs
  const sceneAScale = interpolate(progress, [0, 1], [1, 2.5]);
  const sceneAOpacity = interpolate(progress, [0, 0.5], [1, 0]);
  const sceneABlur = interpolate(progress, [0, 1], [0, 18]);

  // Scene B approaches from depth
  const sceneBScale = interpolate(progress, [0.3, 1], [0.65, 1]);
  const sceneBOpacity = interpolate(progress, [0.3, 0.7], [0, 1]);
  const sceneBBlur = interpolate(progress, [0.3, 1], [14, 0]);

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#F4F2EC",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Inter', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 260,
          backgroundColor: "#1D4ED8",
          color: "#FFFFFF",
          padding: "12px 28px",
          borderRadius: 30,
          fontSize: 22,
          fontWeight: 900,
          letterSpacing: "0.05em",
        }}
      >
        CONTOH 2: PUSH-THROUGH ZOOM (3D DOLLY)
      </div>

      <div style={{ position: "absolute", top: 330, fontSize: 18, color: "#4B5563", fontWeight: 700 }}>
        Kamera menembus masuk ke dalam objek menuju adegan berikutnya.
      </div>

      {frame === transitionStart && <Audio src={staticFile("whoosh.mp3")} volume={0.6} />}
      {frame === transitionEnd && <Audio src={staticFile("chime.mp3")} volume={0.7} />}

      {/* Scene A Outgoing */}
      {progress < 1 && (
        <div
          style={{
            position: "absolute",
            transform: `scale(${sceneAScale})`,
            opacity: sceneAOpacity,
            filter: `blur(${sceneABlur}px)`,
          }}
        >
          <SceneA />
        </div>
      )}

      {/* Scene B Incoming */}
      {progress > 0.2 && (
        <div
          style={{
            position: "absolute",
            transform: `scale(${sceneBScale})`,
            opacity: sceneBOpacity,
            filter: `blur(${sceneBBlur}px)`,
          }}
        >
          <SceneB />
        </div>
      )}
    </AbsoluteFill>
  );
};

// ==========================================
// 3. TRANSISI: SPATIAL CARD MORPH (Deck Swap)
// ==========================================
export const TransisiCardMorph: React.FC = () => {
  const frame = useCurrentFrame();
  const transitionStart = 75;
  const { fps } = useVideoConfig();

  const morphSpring = spring({
    frame: frame - transitionStart,
    fps,
    config: { damping: 14, stiffness: 120 },
  });

  // Card A slides/recedes backward into depth
  const cardAScale = interpolate(morphSpring, [0, 1], [1, 0.85]);
  const cardAY = interpolate(morphSpring, [0, 1], [0, -80]);
  const cardAOpacity = interpolate(morphSpring, [0, 0.6], [1, 0]);

  // Card B flies forward from front with spring overshoot
  const cardBScale = interpolate(morphSpring, [0, 1], [0.8, 1]);
  const cardBY = interpolate(morphSpring, [0, 1], [120, 0]);
  const cardBOpacity = interpolate(morphSpring, [0, 0.4], [0, 1]);

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#F4F2EC",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Inter', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 260,
          backgroundColor: "#059669",
          color: "#FFFFFF",
          padding: "12px 28px",
          borderRadius: 30,
          fontSize: 22,
          fontWeight: 900,
          letterSpacing: "0.05em",
        }}
      >
        CONTOH 3: SPATIAL CARD MORPH (DECK SWAP)
      </div>

      <div style={{ position: "absolute", top: 330, fontSize: 18, color: "#4B5563", fontWeight: 700 }}>
        Kanvas panggung diam, kartu bertukar posisi melayang di ruang 3D.
      </div>

      {frame === transitionStart && <Audio src={staticFile("swoosh-quick.mp3")} volume={0.6} />}
      {frame === transitionStart + 15 && <Audio src={staticFile("ui-pop.mp3")} volume={0.7} />}

      {/* Card A Receding */}
      <div
        style={{
          position: "absolute",
          transform: `perspective(1000px) translateY(${cardAY}px) scale(${cardAScale})`,
          opacity: cardAOpacity,
        }}
      >
        <SceneA />
      </div>

      {/* Card B Approaching */}
      <div
        style={{
          position: "absolute",
          transform: `perspective(1000px) translateY(${cardBY}px) scale(${cardBScale})`,
          opacity: cardBOpacity,
        }}
      >
        <SceneB />
      </div>
    </AbsoluteFill>
  );
};
